import { useState, useEffect } from 'react';
import MainLayout from '../../Layout/MainLayout';
import PageContainer from '../../components/layout/PageContainer';
import { usePartner } from '../../context/partnerManagement/PartnerContext';
import PartnerHeader from './sections/Header/PartnerHeader';
import PartnerList from './sections/PartnerList/PartnerList';
import AddPartnerForm from './sections/AddPartnerForm/AddPartnerForm';
import ViewPartnerDetails from './sections/ViewPartnerDetails/ViewPartnerDetails';

const PartnerManagementPage = () => {
  const { fetchPartners, fetchLocations } = usePartner();
  const [viewMode, setViewMode] = useState('list'); // 'list' | 'form' | 'view'
  const [selectedPartner, setSelectedPartner] = useState(null);

  useEffect(() => {
    fetchLocations();
    fetchPartners();
  }, [fetchLocations, fetchPartners]);

  const handleToggleMode = () => {
    if (viewMode !== 'list') {
      setViewMode('list');
      setSelectedPartner(null);
    } else {
      setSelectedPartner(null);
      setViewMode('form');
    }
  };

  const handleAddNew = () => {
    setSelectedPartner(null);
    setViewMode('form');
  };

  const handleViewPartner = (partner) => {
    setSelectedPartner(partner);
    setViewMode('view');
  };

  const handleEditPartner = (partner) => {
    setSelectedPartner(partner);
    setViewMode('form');
  };

  const handleSuccess = () => {
    setViewMode('list');
    setSelectedPartner(null);
  };

  return (
    <MainLayout activeTab="partners" setActiveTab={() => {}}>
      <PageContainer className="font-sans">
        <PartnerHeader viewMode={viewMode} onToggleMode={handleToggleMode} />

        {viewMode === 'form' ? (
          <div className="bg-white rounded-2xl sm:rounded-3xl shadow-sm border border-slate-100 p-4 sm:p-6 md:p-8 animate-tab-switch">
            <AddPartnerForm initialData={selectedPartner} onSuccess={handleSuccess} />
          </div>
        ) : viewMode === 'view' ? (
          <ViewPartnerDetails
            partner={selectedPartner}
            onBack={() => {
              setViewMode('list');
              setSelectedPartner(null);
            }}
            onEdit={handleEditPartner}
          />
        ) : (
          <PartnerList
            onAddNew={handleAddNew}
            onView={handleViewPartner}
            onEdit={handleEditPartner}
          />
        )}
      </PageContainer>
    </MainLayout>
  );
};

export default PartnerManagementPage;
